/* eslint-disable no-param-reassign */
import _ from 'lodash';
// eslint-disable-next-line import/no-cycle
import lsTrackService from '@/services/ls-track/ls-track.service';
import * as types from '@/store/types';
// eslint-disable-next-line import/no-cycle
import router from '@/router';

export const state = {
    loadingType: 'spinner',
    quotedOrderRoute: {
        name: '',
    },
    quotingOrder: false,
    finalizingOrder: false,
};

export const mutations = {
    [types.LOADING__MUTATE_QUOTING_ORDER](localState, loadingStatus) {
        localState.quotingOrder = loadingStatus;
    },

    [types.LOADING__MUTATE_LOADING_TYPE](localState, loadingType) {
        localState.loadingType = loadingType;
    },

    [types.LOADING__MUTATE_QUOTED_ORDER_ROUTE](localState, route) {
        localState.quotedOrderRoute = route;
    },

    [types.LOADING__MUTATE_FINALIZING_ORDER](localState, { status }) {
        localState.finalizingOrder = status;
    },
};

export const actions = {
    [types.LOADING__QUOTING_ORDER]({ commit }) {
        commit(types.LOADING__MUTATE_QUOTING_ORDER, true);
    },

    // eslint-disable-next-line no-shadow
    [types.LOADING__ORDER_QUOTED]({ commit, state, dispatch }, payload) {
        if (!payload.data.zip_in_market || !payload.data.zip_is_active) {
            commit(types.LOADING__MUTATE_QUOTED_ORDER_ROUTE, { name: 'outOfMarketForm' });
        } else if (!payload.data.order_has_pricing || !_.get(payload, 'data.services.mowing')) {
            commit(types.LOADING__MUTATE_QUOTED_ORDER_ROUTE, { name: 'pricingUnavailableForm' });
        } else {
            const services = _.get(payload, 'data.services');
            lsTrackService.track({
                type: 'price-viewed',
                target: 'order-form',
                data: { services },
            });
            commit(types.LOADING__MUTATE_QUOTED_ORDER_ROUTE, { name: 'singleStepSignupForm' });
        }

        if (state.loadingType !== 'progressBar') {
            dispatch(types.LOADING__GO_TO_QUOTED_ORDER_ROUTE);
        }
    },

    // eslint-disable-next-line no-shadow
    [types.LOADING__GO_TO_QUOTED_ORDER_ROUTE]({ commit, state }) {
        const quotedOrderRouteCopy = _.cloneDeep(state.quotedOrderRoute);
        if (quotedOrderRouteCopy.name) {
            commit(types.LOADING__MUTATE_QUOTING_ORDER, false);
            router.push(quotedOrderRouteCopy);
            commit(types.LOADING__MUTATE_QUOTED_ORDER_ROUTE, { name: '' });
        }
    },

    [types.LOADING__ORDER_ERRORED]({ commit }) {
        commit(types.LOADING__MUTATE_QUOTING_ORDER, false);
    },

    [types.LOADING__FINALIZING_ORDER]({ commit }, { status }) {
        commit(types.LOADING__MUTATE_FINALIZING_ORDER, { status });
    },

    [types.LOADING__SET_LOADING_TYPE]({ commit }, { loadingType }) {
        commit(types.LOADING__MUTATE_LOADING_TYPE, loadingType);
    },
};

export const getters = {};
